import { ComponentProps } from 'react';
import { TextField as CTextField } from '@consta/uikit/TextField';
// Не актуально, использовать UiTextField
export const TextField = (props: ComponentProps<typeof CTextField>) => (
  <CTextField {...props} />
);
